<template>
    <el-container direction="vertical">
        <el-col justify="start" class="pr10">
            <el-form :model="expense" label-position="top">
                <div class="expense-main">
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Отчётный период
                        </el-col>
                        <el-col :span="14" class="period-select">
                            <div class="filter-label">
                                Год
                            </div>
                            <el-select
                                v-model="expense.period_year"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                placeholder="Год"
                                size="mini"
                                clearable
                                class="period-select-year"
                                disabled
                            >
                                <el-option v-for="item in localReferences.yearsList" :key="item" :label="item" :value="item" />
                            </el-select>
                            <div class="filter-label">
                                Месяц
                            </div>
                            <el-select
                                v-model="expense.period_month"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                clearable
                                placeholder="Месяц"
                                size="mini"
                                class="period-select-month"
                                disabled
                            >
                                <el-option v-for="item in localReferences.monthsList" :key="item" :label="item" :value="item" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Касса
                        </el-col>
                        <el-col :span="8">
                            <el-select
                                v-model="expense.office_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                collapse-tags
                                clearable
                                autocomplete
                                size="mini"
                            >
                                <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                        <el-col :span="1" class="gray">
                            &nbsp;
                        </el-col>
                        <el-col :span="7">
                            <el-select
                                v-model="expense.pay_type_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                collapse-tags
                                clearable
                                autocomplete
                                size="mini"
                            >
                                <el-option v-for="item in payTypesList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Получил - тип
                        </el-col>
                        <el-col :span="16">
                            <template v-if="!isNew">
                                {{ this.getName(this.receivedFromTypesList, expense.recipient_type) }}
                            </template>
                            <template v-else>
                                <el-select
                                    v-model="expense.recipient_type"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    clearable
                                    size="mini"
                                    disabled
                                >
                                    <el-option v-for="item in receivedFromTypesListRegular" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </template>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Получил
                        </el-col>
                        <el-col :span="16">
                            <el-select
                                v-model="expense.recipient_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                autocomplete
                                size="mini"
                                disabled
                            >
                                <el-option v-for="item in receivedByIdList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Дата расхода
                        </el-col>
                        <el-col :span="16">
                            <el-date-picker
                                v-model="expense.date"
                                type="date"
                                placeholder="дд.мм.гггг"
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                :clearable="false"
                                size="mini"
                                class="w100"
                                disabled
                            />
                            <div class="field-error bold" v-if="errors.date" v-text="errors.date[0]"></div>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Сумма, руб
                        </el-col>
                        <el-col :span="16">
                            {{ formatFinance(amountResidue) }}
                        </el-col>
                    </el-row>
                    <el-row class="text-center pt16">
                        <el-col>
                            <el-button type="info" @click="close">
                                Отмена
                            </el-button>
                            <el-button type="warning" @click="createExpenses" :disabled="isDisabled">
                                Выдать
                            </el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </el-col>
    </el-container>
</template>
<script>
import ExpenseMixin from '@/mixins/expense';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { pickerOptions } from '@/common/pickerOptions';
import moment from 'moment';
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';
import '@/assets/styles/card.scss';
import { formatFinance } from '@/common/utilities';
import ExpenseDealEdit from '@/components/expenses/ExpenseDealEdit';
import { eventBus } from '@/common/eventBus';
import employers from '@/store/modules/employers';

const initialExpense = {
    id: null,
    created_by_id: null,
    created_at: moment().format('DD.MM.YYYY HH:mm'),
    amount_formatted: ''
};

export default {
    name: 'ExpenseDealCreate',
    mixins: [
        ExpenseMixin
    ],
    props: {
        id: {
            type: [String, Number],
            default: 0
        },
        expenseDefault: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            isDisabled: false,
            expense: {
                created_by_id: this.$store.state.auth.employerId,
                recipient_type: '',
                recipient_id: null,
                source_type: 'cash',
                source_id: null,
                pay_type_id: null,
                office_id: null,
                period_year: '',
                period_month: '',
                report_date: '',
                details: [{
                    expense_type: null,
                    amount: 0
                }],
                comment: ''
            },
            created_by_name: '',
            errors: [],
            loadingMain: false,
            period: [],
            counter: 0,
            amount: 0
        };
    },
    computed: {
        isNew() {
            return this.id === -1;
        },
        amountResidue() {
            return this.$store.state.salary.totalCalculateSum.residue;
        }
    },
    methods: {
        async createExpenses() {
            if (this.amountResidue <= 0 && !this.$store.state.salary.isIssetDealFine) {
                this.$message({
                    showClose: true,
                    message: 'Сумма к выдаче (кроме штрафа) должна быть положительным числом',
                    type: 'error',
                    duration: 5000,
                    customClass: this.alertClass()
                });
                return;
            }
            this.isDisabled = true;
            this.loadingMain = true;
            const expenses = this.$store.state.salary.expensesDeals;
            try {
                await this.$store.dispatch('expenses/createPayrollInfoExpenses', { expenses: expenses, office_id: this.expense.office_id, pay_type_id: this.expense.pay_type_id, employer_id: this.expenseDefault.recipient_id, report_date: this.expenseDefault.report_date });
                this.actionAfterSave();
                this.$router.go();
            } catch (e) {
                this.errors = JSON.parse(e.message);
                this.actionAfterSaveError();
            } finally {
                this.loadingMain = false;
                this.isDisabled = false;
            }
        }
    },
    mounted() {
        const reportDate = this.expenseDefault.report_date.split('-');
        this.expense.recipient_type = this.expenseDefault.recipient_type;
        //console.log(this.$store.state.references.employers.filter(employer => employer.id === this.expenseDefault.recipient_id));
        this.expense.recipient_id = this.expenseDefault.recipient_id;
        this.expense.period_month = reportDate[1];
        this.expense.period_year = reportDate[0];
        this.expense.date = this.expenseDefault.date;
    },
    extends: ExpenseDealEdit
};
</script>
